export default __webpack_public_path__ + "static/media/ballyhactitle.0f07c485.webp";